<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ตั้งค่าหน่วยนับ</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">

          <v-card v-if="type_api == 0" elevation="4" style="border-radius: 15px;">
            <v-card-title style="color:#000;">เพิ่มข้อมูลหน่วยนับ</v-card-title>
            <v-card-text>
              <v-form ref="form" @submit.prevent="createProductSettingList">
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ชื่อหน่วยนับ <span class="required--text">*</span></label>
                      <v-text-field v-if="$store.state.store_arin.user_data.status_main_store == 1" color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-database"
                        v-model="input_set.name" :rules="[v => (v[0] !== ' ' || 'กรุณาอย่าป้อนค่าว่างตัวแรก'), v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" hide-details="auto"
                        placeholder="กรุณากรอกชื่อหน่วยนับ" single-line outlined dense required disabled></v-text-field>
                        
                      <v-text-field v-else color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-database"
                        v-model="input_set.name" :rules="[v => (v[0] !== ' ' || 'กรุณาอย่าป้อนค่าว่างตัวแรก'), v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" hide-details="auto"
                        placeholder="กรุณากรอกชื่อหน่วยนับ" single-line outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">จำนวนชิ้นย่อยภายใน <span class="required--text">*</span></label>
                      <v-text-field v-if="$store.state.store_arin.user_data.status_main_store == 1" color="#D6BFAF" type="tel" maxlength="10" class="input-radius"
                        prepend-inner-icon="mdi-database" v-model="input_set.qty"
                        :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" hide-details="auto"
                        @keypress="isTaxNumber($event, input_set.qty)" placeholder="กรุณากรอกจำนวนชิ้นย่อยภายใน" single-line
                        outlined dense required disabled></v-text-field>

                        <v-text-field v-else color="#D6BFAF" type="tel" maxlength="10" class="input-radius"
                        prepend-inner-icon="mdi-database" v-model="input_set.qty"
                        :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" hide-details="auto"
                        @keypress="isTaxNumber($event, input_set.qty)" placeholder="กรุณากรอกจำนวนชิ้นย่อยภายใน" single-line
                        outlined dense required></v-text-field>
                    </v-form-group>
                    <div class="title_page mt-3" style="justify-content:center;">
                      <v-btn type="submit" v-if="$store.state.store_arin.user_data.status_main_store == 1" class="btn_add_data" elevation="4" large disabled>บันทึก</v-btn>
                      <v-btn type="submit" v-else class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>

          <v-card v-else elevation="4" style="border-radius: 15px;">
            <v-card-title style="color:#000;">แก้ไขข้อมูลหน่วยนับ</v-card-title>
            <v-card-text>
              <v-form ref="form" @submit.prevent="editProductSettingList">
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ชื่อหน่วยนับ <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-database"
                        v-model="input_set.name" :rules="[v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" hide-details="auto"
                        placeholder="กรุณากรอกชื่อหน่วยนับ" single-line outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">จำนวนชิ้นย่อยภายใน <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-database"
                        v-model="input_set.qty" :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" hide-details="auto"
                        placeholder="กรุณากรอกจำนวนชิ้นย่อยภายใน" single-line outlined dense required></v-text-field>
                    </v-form-group>
                    <div class="title_page mt-3" style="justify-content:center;">
                      <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>

        </v-col>
        <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title style="display: flex;justify-content: flex-end;">
              <div>
                <v-text-field color="#D6BFAF" class="input-radius inp-text-field" append-icon="mdi-magnify"
                  hide-details="auto" required v-model="search" placeholder="ค้นหา..." single-line outlined
                  dense></v-text-field>
              </div>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="product_setting_list" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">

                  <tr>
                    <td class="hidden_line">{{ dataDetail.item.name }}</td>
                    <td class="hidden_line text-center">{{ dataDetail.item.qty }}</td>
                    <td class="hidden_line text-center">
                      <v-btn v-if="$store.state.store_arin.user_data.status_main_store == 1" elevation="4" class="ma-2" outlined color="#FEA06C" title="แก้ไขรายละเอียด" small height="45"
                        @click="getEditProductSetting(dataDetail.item.id);" style="border-radius:10px" disabled>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>

                      <v-btn v-else elevation="4" class="ma-2" outlined color="#FEA06C" title="แก้ไขรายละเอียด" small height="45"
                        @click="getEditProductSetting(dataDetail.item.id);" style="border-radius:10px">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </td>
                  </tr>

                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </div>
  </div>
</template>
<script>
import cancel_order from "@/assets/arin_assets/cancel_order.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
import { taxNumber } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Product setting",
  data() {
    return {
      loading_page: false,
      img_cancel_order: cancel_order,
      search: '',
      edit_unit_detail: false,
      product_setting_list: [],
      input_set: [],
      type_api: 0,
      phoneRules: [v => (v.length > 8) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      headers: [
        {
          text: 'ชื่อหน่วยนับ',
          value: 'name',
          fixed: true,
          width: '100px',
        },
        {
          text: 'จำนวนต่อหน่วย',
          value: 'qty',
          fixed: true,
          align: 'center',
          width: '20px',
        },
        {
          text: 'จัดการ',
          value: 'tool',
          fixed: true,
          sortable: false,
          align: 'center',
          width: '20px',
        },
      ],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังหน่วยนับ',
          disabled: false,
        },
        {
          text: 'ตั้งค่าหน่วยนับ',
          disabled: false,
          href: '#',
        },
      ],
    }
  },
  methods: {
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },

    // GET ข้อมูลบัญชี
    getProductSettingList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/unitlist', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.product_setting_list = res.data.unitList;
        }
      })
    },

    // GET ข้อมูลบัญชีเพื่อแก้ไข
    getEditProductSetting(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/unitdetail/' + id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.input_set = res.data.unitDetail
          this.type_api = 1
        }
        console.log(this.input_set);
      })
    },

    // ฟังค์ชั่น การนำไป save
    createProductSettingList() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        let data = {
          "name": this.input_set.name,
          "qty": this.input_set.qty,
        }
        // ส่งไปเพิ่ม
        HTTP_ARIN.post('/product/addunitstore', data, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            } else {
              Swal.fire({
                title: 'ไม่สามารถดำเนินการได้!',
                text: 'มีหน่วยนับนี้แล้ว!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
      }
    },

    // ฟังค์ชั่น การนำไป edit
    editProductSettingList() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        HTTP_ARIN.post('/product/editunit/' + this.input_set.id, this.input_set, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'แก้ไขข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'ไม่สามารถดำเนินการได้!',
                text: 'มีหน่วยนับนี้แล้ว!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
      }
    },

  }
  ,
  mounted() {
    this.getProductSettingList()
  }
}
</script>

<style scoped>
.pa-40 {
  padding: 40px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.line-grid {
  display: inline-grid;
}

.font-20 {
  font-size: 20px;
}

.title-flex-center {
  display: flex;
  align-items: center;
}

.title-flex-baseline {
  display: flex;
  align-items: baseline;
  font-size: 16px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #D6BFAF;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #D6BFAF;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;

}

.title_form_header_text {
  color: #616A6B;
}


.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}



.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;

}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 40%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}
</style>
